<div class="page-content-contact">
  <owc-breadcrumb>
    <owc-breadcrumb-item *ngFor="let breadcrumb of breadcrumbs; last as isLast; first as isFirst; even as isEven; odd as isOdd">

      <span *ngIf="isFirst" class="mat-caption" routerLinkActive="router-link-active" (click)="gotoNotificationPage($event)">
        {{ breadcrumb.label }}
      </span>

      <span *ngIf="isOdd && !isFirst && !isLast && !isEven" class="mat-caption" routerLinkActive="router-link-active" (click)="gotoNotificationDetailsPage($event)">
        {{ breadcrumb.label }}
      </span>

      <span *ngIf="isEven && !isFirst && !isLast && !isOdd" class="mat-caption" routerLinkActive="router-link-active" (click)="gotoAccountDetailsPage($event)">
        {{ breadcrumb.label }}
      </span>

      <span *ngIf="isLast" class="mat-small">
        {{ breadcrumb.label }}
      </span>

    </owc-breadcrumb-item>
  </owc-breadcrumb>

  <div class="contact-detail-container">

    <p class="cd-header">{{ customerTitle }}</p>

    <div class="cd-card-container" style="display: flex; gap:20px">

      <owc-card class="cd-card-list cd-onecard" style="height: auto;">

        <owc-component-header class="cd-mat-card">
          <div class="cd-card-title recipient-header">
            <span>Recipient</span>
          </div>
        </owc-component-header>

        
          <form [formGroup]="recepientForm">

            <div class="cd-item">

              <div class="cd-title">Source</div>

              <div *ngIf="!showEditControls" class="cd-chip-value">
                <owc-chip class="customer-details-source-chip truncate-text" oneChip oneChipAppearance="outline" *ngIf="customerData.DataSource && customerData.DataSource.length > 0" [title]="customerData.DataSource">
                  {{ customerData.DataSource }}
                </owc-chip>
              </div>

              <div *ngIf="showEditControls">
                <owc-input formControlName="recepientSource" class="cd-edit-value" />
                <owc-assistive-text *ngIf="recepientForm.controls['recepientSource'].invalid" style="margin-top: 5px;">
                  Source name must be at least 2 characters and should not contain any special character
                </owc-assistive-text>
              </div>

            </div>

            <div class="cd-item">

              <div class="cd-title">Contact name</div>

              <div *ngIf="!showEditControls" class="cd-value truncate-text" [title]="customerData.CustomerContactName">
                {{ customerData.CustomerContactName }}
              </div>

              <div *ngIf="showEditControls">
                <owc-input formControlName="recepientName" class="cd-edit-value" />
                <owc-assistive-text *ngIf="recepientForm.controls['recepientName'].invalid" style="margin-top: 5px;">
                  Contact name must be at least 2 characters and should not contain any numeric or special character
                </owc-assistive-text>
              </div>

            </div>

            <div class="cd-item">

              <div class="cd-title">Contact email</div>

              <div *ngIf="!showEditControls" class="cd-value truncate-text" [title]="customerData.CustomerContactEmail">
                {{ customerData.CustomerContactEmail }}
              </div>

              <div *ngIf="showEditControls">
                <owc-input formControlName="recepientEmail" [ngClass]="{ disabled: !isResendEnabled }" class="cd-edit-value" />
                <owc-assistive-text *ngIf="recepientForm.controls['recepientEmail'].invalid" style="margin-top: 5px;">
                  Email must be in in proper email format (i.e abc&#64;abc.com)
                </owc-assistive-text>
              </div>

            </div>

            <div class="cd-item">

              <div class="cd-title">Account name</div>

              <div class="cd-value truncate-text" [title]="customerData.CustomerName">
                {{ customerData.CustomerName }}
              </div>

            </div>

          </form>
       
        
      <div>
        
        <div *ngIf="!userPermission.SendNotification" style="margin: 2%;display: flex;gap: 20px;justify-content: flex-end;">
          <owc-button mat-stroked-button one-secondary-button (click)="viewAuditTrail()">Audit trail</owc-button>
        </div>
    
        <div *ngIf="!showEditControls && userPermission.SendNotification" style="margin: 2%;display: flex;gap: 20px;justify-content: flex-end;">
          <owc-button mat-stroked-button one-secondary-button (click)="viewAuditTrail()">Audit trail</owc-button>
          <owc-button one-secondary-button mat-stroked-button [disabled]="isEditDisabled || isSetCom || isNotiStat || customerNotificationData.Status === 'Superseded'" (click)="openEditForm()">Edit</owc-button>
        </div>

         <owc-modal-dialog [(ngModel)]="visibleAuditTrail">
          <dl-notification-audit-trail [inputData]="inputData"
            (closed)="visibleAuditTrail = false"></dl-notification-audit-trail>
        </owc-modal-dialog>

        <div *ngIf="showEditControls && userPermission.SendNotification" style="margin: 2%;display: flex;gap: 20px;justify-content: flex-end;">
          <owc-button one-secondary-button mat-stroked-button class="cd-close" (click)="closeEditForm()">Cancel</owc-button>
          <owc-button color="primary" mat-flat-button [disabled]="recepientForm.invalid" (click)="editRecepientDetails()">Save</owc-button>
        </div>
      
      </div>

      </owc-card>

      <owc-card  class="cd-card-list cd-onecard" style="height: auto;">

        <owc-component-header>
          
          <div class="communication-header">
            <span style="font-size: 20px;">Communication</span>
            <owc-chip class="customer-details-source-chip truncate-text" oneChip oneChipAppearance="outline" [title]="customerData.Status"> {{ displayStatus(customerData.Status) }}</owc-chip>
          </div>

        </owc-component-header>
        

        <div style="display: block;">

          <div class="cd-item">

            <div class="cd-title">Date sent</div>

            <div class="cd-value" [title]="appUtils.formatDateWithTime(customerData.DateSent)">
              {{ appUtils.formatDateWithTime(customerData.DateSent) }}
            </div>

          </div>

          <div class="cd-item">

            <div class="cd-title">Date delivered</div>

            <div class="cd-value" [title]="appUtils.formatDateWithTime(customerData.DateDelivered)">
              {{ appUtils.formatDateWithTime(customerData.DateDelivered) }}
            </div>

          </div>

          <div class="cd-item">

            <div class="cd-title">Date read</div>

            <div class="cd-value" [title]="appUtils.formatDateWithTime(customerData.DateRead)">
              {{ appUtils.formatDateWithTime(customerData.DateRead) }}
            </div>

          </div>

          <div class="cd-item">

            <div class="cd-title">Feedback received</div>

            <div class="cd-value" [title]="appUtils.formatDateWithTime(customerData.FeedbackReceived)">
              {{ appUtils.formatDateWithTime(customerData.FeedbackReceived) }}
            </div>
          
          </div>

          <div class="cd-item">

            <div class="cd-title">Resend Date</div>

            <div class="cd-value" [title]="appUtils.formatDateWithTime(customerData.ResendDate)">
              {{ appUtils.formatDateWithTime(customerData.ResendDate) }}
            </div>

          </div>

        <div class="cd-feedback-list-actionbutton" style="margin: 2%;display: flex;gap: 20px;justify-content: flex-end;">

          <owc-button [disabled]="isSetCom || isNotiStat" *ngIf="customerNotificationData.NotificationReminders && customerNotificationData.NotificationReminders.length > 0"  class="btn-mr" title="View reminders" (click)="viewReminders()">View reminders</owc-button>
          <owc-button [disabled]="isSetCom || isNotiStat || customerNotificationData.Status === 'Superseded'" *ngIf="userPermission.SendNotification && isResendEnabled" title="Resend notification" (click)="onResendNotification($event)">Resend notification</owc-button>
        
        </div>
        </div>
         <owc-modal-dialog [(ngModel)]="visibleView">
          <app-view-reminder-details [data]="data" (close)="visibleView = false"></app-view-reminder-details>
        </owc-modal-dialog>

      </owc-card>
    </div>

    <div>

      <!-- Acknowledgement -->
      <div [hidden]="accDataObj.AccountStatus === 'Feedback Received' && accDataObj.AccountSubmitter !== customerData.CustomerContactEmail && accDataObj.AccountSubmitter !== undefined">
        <owc-card class="cd-card-customer">

          <owc-component-header class="cd-mat-card">
            <span class="cd-feedback-title">LSO Acknowledgement</span>
          </owc-component-header>

         
            <div class="cd-feedback-list">

              <div class="cd-feedback-list-subject" style="margin-left: 15px; margin-bottom: 10px;">
                Provide acknowledgement on behalf of the contact.
              </div>

              <div *ngIf="ackComment" style="margin-left: 15px">

                <div class="cd-feedback-list-title" style="margin-bottom: 5px;">
                  Comments
                </div>

                <div class="cd-feedback-list-subject">
                  {{ackComment}}
                </div>

                 <div class="cd-feedback-list-title" style="margin-bottom: 5px; margin-top: 10px">
                        Attachments
                  </div>

                <div class="cd-files-list" style="margin-block:10px; width:fit-content;" *ngIf="ackFileName">
                  <div class="single-file">
                    <div class="info" (click)="downloadLSOAttachment(ackFileName, NotificationId, contactNotificationId)" style="display: flex; gap: 10px; margin-right:8rem;">
                      
                      <owc-icon class="one-icons iconcls">{{ appUtils.formatFilesIcons(ackFileName) }}</owc-icon>
                      
                      <div style="display: flex; flex-direction: column; gap: 10px;">
                        <span class="name"> {{ackFileName}} </span>
                        <span class="size"> {{ackFileSize}} </span>
                      </div>

                    </div>
                  </div>
                </div>

              </div>

              <owc-button [disabled]="!userPermission.SendNotification || isEditDisabled || isSetCom || isNotiStat || isDisabled || customerNotificationData.Status === 'Superseded'|| (accDataObj.AccountStatus === 'Feedback Received' && accDataObj.AccountSubmitter !== customerData.CustomerContactEmail && accDataObj.AccountSubmitter !== undefined)" 
              *ngIf="!ackComment" one-secondary-button mat-stroked-button (click)="lsoAcknowledgement()"
              style="margin-left: 15px; margin-bottom: 10px;">
                Acknowledge
              </owc-button>
               <owc-modal-dialog [(ngModel)]="acknowledgementVisible">
          <dl-lso-acknowledgement (closed)="onAcknowledgementClosed($event)"></dl-lso-acknowledgement>
        </owc-modal-dialog>

            </div>
         

        </owc-card>
      </div>

      <div>
  
  
        <!-- Email Evidence -->
        <owc-card class="cd-card-customer">
  
          <owc-component-header class="cd-mat-card">
            <div class="cd-feedback-title">Email Delivery Evidence</div>
          </owc-component-header>
  
            <div *ngFor="let attachment of customerData.EmailEvidenceDocuments" style="margin-left: 15px; margin-bottom: 10px;">
              <div class="cd-files-list" >
                <div class="single-file">
                  <div class="info" (click)="downloadEmailEvidence( attachment.Filename )">
                    
                    <owc-icon class="one-icons iconcls">{{ appUtils.formatFilesIcons('pdf') }}</owc-icon>
                    
                    <div style="margin-left:10px">
                      <p class="name"> {{ attachment.Filename }}.pdf </p>
                      <p class="size" style="display: flex; justify-content: space-between; margin-top: 10px;">
                        <span>{{ attachment.TimeStamp | date:"dd-MMM-yyyy hh:mm a" }}</span>
                        <span> {{ attachment.FileSize }}</span>
                      </p>
                    </div>
  
                  </div>
                </div>
              </div>
            </div>
  
        </owc-card>
  
      </div>
  
    </div>
    
  